import { render, staticRenderFns } from "./details-evaluate.vue?vue&type=template&id=9174ff06&scoped=true"
import script from "./details-evaluate.vue?vue&type=script&lang=js"
export * from "./details-evaluate.vue?vue&type=script&lang=js"
import style0 from "./details-evaluate.vue?vue&type=style&index=0&id=9174ff06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9174ff06",
  null
  
)

export default component.exports